
import {getListGroups} from '../api/getListGroups';
import {setGetListGroupsAction} from '../action';

const setGetListGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListGroups(params);

            if (data.status === 'success') {
                dispatch(setGetListGroupsAction({
                    list: data.groups,
                    summ: data.summ
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListGroups
}